// @flow
import React from "react";
import PlayerProfile from "../../components/PlayerProfile";


const PlayerClassic = (props: Object) => {
	return <PlayerProfile is_classic {...props} />;
};

export default PlayerClassic;